// extracted by mini-css-extract-plugin
export default {"containerTimeSlot":"PatchTimeSelection_containerTimeSlot__lGCyg","title":"PatchTimeSelection_title__qVx3Z"};